import { tripPlannerMainComponent } from './trip-planner-main.component';

export const tripPlannerMain = angular
    .module('components.tripPlanner.tripPlannerMain', [])
    .component('tripPlannerMainComponent', tripPlannerMainComponent)
    .config(($stateProvider) => {
        'ngInject';

        $stateProvider
            .state('tripPlannerResults', {
                url: '/trip-planner?originName&destinationName&originLat&originLng&destinationLat&destinationLng&originServiceAreas&destinationServiceAreas&requirements&isVeteran&isMedicaid&serviceTypeName&age',
                component: 'tripPlannerMainComponent',
                breadcrumbName: 'Results',
                parentState: 'tripPlannerLandingPage',
                resolve: {
                    privateProvidersDetails($stateParams, TripPlannerService) {
                        'ngInject';

                        const { originServiceAreas = [], originLat = "", originLng = "", destinationServiceAreas = [], destinationLat = "", destinationLng = "", requirements = "", isVeteran = null, isMedicaid = null, serviceTypeName = "" } = $stateParams;
                        const serviceTypeId = "";


                        return TripPlannerService.getPrivateProvidersDetails({
                            originServiceAreas,
                            destinationServiceAreas,
                            isVeteran,
                            isMedicaid,
                            requirements,
                            serviceTypeName,
                            serviceTypeId
                        });
                    },
                    directionDetails($stateParams) {
                        'ngInject';

                        const { originName, destinationName, originLat, originLng, destinationLat, destinationLng } = $stateParams;

                        return {
                            originName,
                            destinationName,
                            directionLatLngInfo: {
                                origin: {
                                    lat: originLat,
                                    lng: originLng
                                },
                                destination: {
                                    lat: destinationLat,
                                    lng: destinationLng
                                }
                            }
                        };
                    },
                    advanceOptionsDetails($stateParams, $parse) {
                        'ngInject';
                        const { requirements = "", isVeteran = null, isMedicaid = null, serviceTypeName = "", age = "", originServiceAreas = "", destinationServiceAreas = "" } = $stateParams;

                        return {
                            originServiceAreas,
                            destinationServiceAreas,
                            serviceTypeName,
                            requirements,
                            age,
                            isVeteran: isVeteran !== null ? $parse(isVeteran || 'false')(false) : null,
                            isMedicaid: isMedicaid !== null ? $parse(isMedicaid || 'false')(false) : null
                        };
                    },
                    contactInfo(HomeService) {
                        'ngInject';

                        return HomeService.getContactInfoDetails();
                    }
                }
            });
    })
    .name;


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-main/trip-planner-main.module.js